import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://www.angelprinters.com/api'),
  timeout: 15000,
});

// Attach JWT token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('printspace_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle expired token globally
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('printspace_token');
      localStorage.removeItem('printspace_user');
      localStorage.removeItem('printspace_last_activity');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
